'use client'

import type { Collection } from '@/types/collection.types'

interface PublicCollectionChipsProps {
  collections: Collection[]
  activeCollectionId: string | null
  onSelect: (collectionId: string | null) => void
}

/**
 * Horizontal chip filter for public profile view.
 * Shows "All" + public collection chips. Scrollable when >5.
 */
export function PublicCollectionChips({
  collections,
  activeCollectionId,
  onSelect,
}: PublicCollectionChipsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      <button
        onClick={() => onSelect(null)}
        className={`
          shrink-0 rounded-full px-4 py-1.5 text-sm font-medium transition-colors
          ${
            activeCollectionId === null
              ? 'bg-[var(--color-brand-indigo)] text-white'
              : 'bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]'
          }
        `}
      >
        All
      </button>

      {collections.map((col) => (
        <button
          key={col.id}
          onClick={() => onSelect(col.id)}
          className={`
            shrink-0 rounded-full px-4 py-1.5 text-sm font-medium transition-colors
            ${
              activeCollectionId === col.id
                ? 'bg-[var(--color-brand-indigo)] text-white'
                : 'bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]'
            }
          `}
        >
          {col.emoji} {col.name}
        </button>
      ))}
    </div>
  )
}
